<template>
  <div class="page-wrapper">
    <!-- ── Page Header ── -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">Preferred OJT Locations</h1>
        <p class="page-subtitle">
          Manage OJT Location for student-to-organization matching
        </p>
      </div>
      <div class="header-right">
        <v-btn color="#16a34a" class="add-btn" elevation="0" @click="addnew">
          <v-icon start size="18">mdi-plus</v-icon>
          ADD NEW LOCATION
        </v-btn>
      </div>
    </div>

    <!-- ── Skills Table Card ── -->
    <div class="content-card">
      <div class="card-toolbar">
        <div class="toolbar-left">
          <span class="card-title">Locations List</span>
          <span class="count-chip" v-if="data.length > 0">{{
            data.length
          }}</span>
        </div>
        <div class="toolbar-right">
          <v-text-field
            v-model="search"
            placeholder="Search location..."
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            density="compact"
            hide-details
            clearable
            class="search-field"
            color="#16a34a"
          />
        </div>
      </div>

      <v-divider></v-divider>

      <v-data-table
        :headers="headers"
        :items="data"
        :search="search"
        :loading="loading"
        hover
        :items-per-page="10"
        density="comfortable"
        class="skills-table"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <div class="action-btns">
            <v-btn
              class="action-btn edit-btn"
              elevation="0"
              size="small"
              @click="editItem(item)"
            >
              <v-icon size="14" class="mr-1">mdi-pencil</v-icon>
              EDIT
            </v-btn>
            <!-- <v-btn
              class="action-btn delete-btn"
              elevation="0"
              size="small"
              @click="deleteItem(item)"
            >
              <v-icon size="14" class="mr-1">mdi-delete-outline</v-icon>
              DELETE
            </v-btn> -->
          </div>
        </template>

        <template #no-data>
          <div class="empty-state">
            <v-icon size="40" color="#d1d5db">mdi-lightbulb-off-outline</v-icon>
            <p>No preferred skills found.</p>
          </div>
        </template>
      </v-data-table>
    </div>

    <!-- ── Dialogs ── -->
    <PreferredOJTLocationDialog :data="updateData" :action="action" />

    <v-dialog v-model="dialogConfirmDelete" max-width="420">
      <v-card class="confirm-dialog">
        <div class="dialog-header">
          <div class="dialog-icon-wrap">
            <v-icon size="22" color="#dc2626">mdi-delete-outline</v-icon>
          </div>
          <div>
            <div class="dialog-title">Delete Skill</div>
            <div class="dialog-sub">This action cannot be undone.</div>
          </div>
        </div>
        <v-divider></v-divider>
        <div class="dialog-body">
          Are you sure you want to delete this skill? It will be permanently
          removed from the system.
        </div>
        <v-divider></v-divider>
        <div class="dialog-actions">
          <v-btn
            class="dialog-cancel-btn"
            elevation="0"
            @click="dialogConfirmDelete = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="dialog-confirm-btn"
            elevation="0"
            @click="confirmDelete"
          >
            Delete
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      :displayType="'variation2'"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import PreferredOJTLocationDialog from "../Dialogs/Forms/PreferredOJTLocationDialog.vue";
export default {
  components: { PreferredOJTLocationDialog },
  data: () => ({
    search: "",
    headers: [
      { title: "Location", value: "location", align: "start" },
      {
        title: "Actions",
        value: "actions",
        align: "end",
        sortable: false,
        width: 200,
      },
    ],
    data: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    totalCount: 0,
    deleteData: null,
    updateData: null,
    alerted: false,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    work_dates_menu: false,
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),
  mounted() {
    this.initialize();
    eventBus.on("closePreferredLocationDialog", () => {
      this.initialize();
    });
  },
  beforeUnmount() {
    eventBus.off("closePreferredLocationDialog");
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },
    initialize() {
      this.loading = true;
      this.axiosCall(
        "/preferred-area-for-deployment/getByInstitute",
        "GET",
      ).then((res) => {
        if (res) {
          this.data = res.data;
          this.loading = false;
        }
      });
    },
    addnew() {
      this.updateData = [{ id: null }];
      this.action = "Add";
    },
    // deleteItem(item) {
    //   console.log(item);
    //   this.alerted = true;
    //   // this.dialogConfirmDelete = true;
    //   // this.deleteData = item;
    // },
    editItem(item) {
      this.updateData = item;
      this.action = "Update";
    },
    // confirmDelete() {
    //   this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
    //     () => {
    //       this.fadeAwayMessage.show = true;
    //       this.itemData = null;
    //       this.initialize();
    //     },
    //   );
    // },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap");

.page-wrapper {
  font-family: "Plus Jakarta Sans", sans-serif;

  min-height: 100vh;

  color: #111827;
}

/* ── Header ── */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
.page-title {
  font-size: 1.55rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 3px;
  letter-spacing: -0.02em;
}
.page-subtitle {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
}
.add-btn {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  letter-spacing: 0.05em !important;
  border-radius: 8px !important;
  padding: 0 20px !important;
  height: 40px !important;
  color: #fff !important;
}

/* ── Content Card ── */
.content-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
}

.card-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  gap: 16px;
}
.toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.count-chip {
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  color: #374151;
  padding: 1px 9px;
}

/* Search field */
.search-field {
  min-width: 220px;
}
.search-field :deep(.v-field) {
  border-radius: 8px !important;
  background: #f9fafb !important;
  font-family: "Plus Jakarta Sans", sans-serif !important;
}
.search-field :deep(.v-field__outline__start),
.search-field :deep(.v-field__outline__end),
.search-field :deep(.v-field__outline__notch) {
  border-color: #e5e7eb !important;
}
.search-field :deep(.v-field--focused .v-field__outline__start),
.search-field :deep(.v-field--focused .v-field__outline__end),
.search-field :deep(.v-field--focused .v-field__outline__notch) {
  border-color: #16a34a !important;
}
.search-field :deep(input) {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  font-size: 13px !important;
  color: #111827 !important;
}

/* ── Table ── */
.skills-table :deep(.v-data-table__th) {
  background: #f9fafb !important;
  color: #6b7280 !important;
  font-family: "Plus Jakarta Sans", sans-serif !important;
  font-size: 11.5px !important;
  font-weight: 600 !important;
  letter-spacing: 0.04em !important;
  text-transform: uppercase !important;
  border-bottom: 1px solid #f3f4f6 !important;
  padding: 11px 20px !important;
}
.skills-table :deep(td) {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  font-size: 13px !important;
  color: #374151 !important;
  padding: 10px 20px !important;
  border-bottom: 1px solid #f9fafb !important;
}
.skills-table :deep(.v-data-table__tr:hover > td) {
  background: #f9fafb !important;
}

/* Action buttons */
.action-btns {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.action-btn {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.05em !important;
  border-radius: 6px !important;
  height: 28px !important;
  padding: 0 10px !important;
  text-transform: uppercase !important;
}

.edit-btn {
  background: #dcfce7 !important;
  color: #15803d !important;
  border: 1px solid #bbf7d0 !important;
}
.edit-btn:hover {
  background: #bbf7d0 !important;
}

.delete-btn {
  background: #fee2e2 !important;
  color: #dc2626 !important;
  border: 1px solid #fecaca !important;
}
.delete-btn:hover {
  background: #fecaca !important;
}

/* Empty state */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 56px 20px;
  gap: 10px;
}
.empty-state p {
  font-size: 13px;
  color: #9ca3af;
  text-align: center;
}

/* ── Confirm Dialog ── */
.confirm-dialog {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  border-radius: 14px !important;
  overflow: hidden;
}

.dialog-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 20px 16px;
}

.dialog-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #fee2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dialog-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}
.dialog-sub {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 2px;
}

.dialog-body {
  padding: 16px 20px;
  font-size: 13px;
  color: #6b7280;
  line-height: 1.6;
}

.dialog-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
}

.dialog-cancel-btn {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  background: #f3f4f6 !important;
  color: #374151 !important;
  border: 1px solid #e5e7eb !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  height: 36px !important;
  padding: 0 16px !important;
}

.dialog-confirm-btn {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  background: #dc2626 !important;
  color: #fff !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  height: 36px !important;
  padding: 0 16px !important;
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 14px;
  }
  .card-toolbar {
    flex-direction: column;
    align-items: flex-start;
  }
  .search-field {
    min-width: 100%;
    width: 100%;
  }
}
</style>
